import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette }) => ({
  content: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: '2rem',
    width: '100%',
    alignItems: 'flex-start',
  },

  addressContent: {
    paddingTop: spacing(6),
  },

  required: {
    color: Theme.Colors.Red.Base,
    marginLeft: spacing(4),
  },
  errorMessage: {
    color: `${palette.error.main} !important`,
    margin: 0,
    fontSize: spacing(10.5),
    fontFamily: 'Roboto',
    height: spacing(10),
    display: 'flex !important',
  },
  linkWrapper: {
    marginTop: spacing(24),
  },

  link: {
    color: Theme.Colors.Primary.Base,
    fontSize: Theme.Typography.FontSize.XXSmall,
    fontWeight: Theme.Typography.FontWeight.Medium,
  },

  compactAutocomplete: {
    '& .MuiInputBase-root': {
      minHeight: '22px !important',
      alignItems: 'flex-end',
    },
    '& .MuiInputBase-input': {
      fontSize: spacing(14),
      lineHeight: '20px',
      paddingBottom: '0 !important',
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child': {
      paddingBottom: '0 !important',
      paddingTop: '2px !important',
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(0, 1.5px) scale(1)',
      fontSize: 14,
      color: Theme.Colors.Grayscale.Eighty,
    },
  },
  unidAutocompleteSpacing: {
    '&& .MuiInputLabel-root.MuiInputLabel-shrink': {
      transform: 'translate(0, -18px) scale(1) !important',
    },
    '&& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input': {
      paddingTop: '12px !important',
    },
  },
  fieldOverlayWrapper: {
    position: 'relative',
    width: '100%',
  },
  clickBlockOverlay: {
    position: 'absolute',
    inset: 0,
    zIndex: 1,
    cursor: 'pointer',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    maxHeight: 'calc(100vh - 320px)',
    overflowY: 'auto',
    overflowX: 'hidden',
  },

  valuesContent: {
    flex: 1,
    paddingBottom: spacing(56),
    marginBottom: spacing(16),
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr ',
    gap: '2rem',
    width: '100%',
    alignItems: 'flex-start',

    paddingLeft: spacing(52),
    marginBottom: spacing(4),
    boxSizing: 'border-box',
  },

  rowTotals: {
    display: 'grid',
    gridTemplateColumns: 'repeat(6, 1fr)',
    gap: '2rem',
    width: '100%',
    paddingTop: spacing(62),
    alignItems: 'flex-end',
  },

  rowSingle: {
    display: 'flex',
    alignItems: 'center',
    gap: '2rem',
    width: '100%',
    '& > :first-child': {
      flex: 1,
      minWidth: 0,
    },
  },
  rowOneColumn: {
    gridColumn: '1 / 2',
  },

  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  divider: {
    backgroundColor: Theme.Colors.Grayscale.Twelve,
    margin: 0,
    width: '100%',
    marginBottom: spacing(16),
  },

  footer: {
    position: 'sticky',
    bottom: 0,
    background: '#fff',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 2,
    gap: spacing(12),
  },

  footerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: spacing(2),
  },
  label: {
    fontSize: spacing(14),
    fontWeight: Theme.Typography.FontWeight.Medium,
    color: Theme.Colors.Grayscale.Eighty,
    marginBottom: 0,
    '&.Mui-disabled': {
      color: '#9E9E9E !important',
    },
  },
  selectLabel: {
    '&.MuiInputLabel-root': {
      fontSize: '18px !important',
      color: Theme.Colors.Grayscale.Eighty,
      fontWeight: Theme.Typography.FontWeight.Medium,
    },
    '&.MuiInputLabel-root.Mui-disabled': {
      color: '#9E9E9E !important',
    },
  },
  compartmentHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 0,
    marginBottom: '-16px',
  },
  detailsContainer: {
    display: 'block',
    paddingLeft: spacing(52),
    width: '100%',
    boxSizing: 'border-box',
  },
  materialValuesContainer: {
    display: 'grid',
    gridTemplateColumns: '14px 1fr 110px 100px 150px 150px 50px 50px',
    gap: '1rem',
    marginBottom: spacing(12),
  },
  materialsHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 0,
    marginLeft: '-52px',
  },

  numberInput: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '56px',
    fontSize: '14px',
    fontWeight: '500',
  },
  laborContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    marginLeft: spacing(48),
  },
  laborSummaryRow: {
    display: 'flex',
    gap: '1rem',
    width: '100%',
    paddingLeft: spacing(52),
    marginBottom: spacing(12),
    boxSizing: 'border-box',
    alignItems: 'flex-start',
  },
  laborTypeField: {
    marginTop: spacing(2),
  },
  readOnlyField: {
    '& .MuiInputBase-root': {
      height: '40px',
      width: '180px',
    },
    '& .MuiInputBase-input': {
      fontSize: '14px',
    },
  },
  tooltipLabel: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
    alignItems: 'center',
  },
  tooltipIcon: {
    fontSize: spacing(16),
    padding: 0,
    fill: palette.gray[64],
    margin: 0,
  },
  inputCompact: {
    '& .MuiInputBase-input': {
      fontSize: '14px',
    },
  },
  propertyCodeField: {
    marginTop: spacing(16),
    '& .MuiInputBase-root': {
      minHeight: '22px',
      alignItems: 'flex-end',
    },
    '& .MuiInputBase-input': {
      fontSize: '14px',
      lineHeight: '20px',
      paddingBottom: '0 !important',
    },
  },
}))

export const useResolutionsStyles = makeStyles(({ spacing }) => ({
  main: {
    borderRadius: spacing(8),
    border: '1px solid #E0E0E0',
    marginTop: spacing(16),
    paddingRight: spacing(16),
    paddingBottom: spacing(16),

    '&:first-child': {
      marginTop: 0,
    },

    '&:nth-child(even)': {
      backgroundColor: '#F5F5F5',
    },

    '&:nth-child(odd)': {
      backgroundColor: '#E3F2FD',
    },
  },
}))
